import {
  AccountStateKey,
  AccountStatus,
  TerminationReason,
} from '@monorepo/types';

export const TERMINATION_REASON_LABELS: Record<TerminationReason, string> = {
  [TerminationReason.Cancelled]: 'Cancelled',
  [TerminationReason.Refunded]: 'Refunded',
  [TerminationReason.Withdraw]: 'Withdraw',
  [TerminationReason.OverNight]: 'Overnight',
  [TerminationReason.Weekend]: 'Weekend',
};

export const formatTerminationReason = (reason: TerminationReason): string =>
  TERMINATION_REASON_LABELS[reason] ?? reason;

export const ACCOUNT_STATE_TITLES = {
  [AccountStateKey.Terminated]: 'Termination',
  [AccountStateKey.DailyPause]: 'Daily Pause',
  [AccountStateKey.DailyLoss]: 'Daily Loss',
  [AccountStateKey.Target]: 'Target',
  [AccountStateKey.Expired]: 'Expired',
};

export const isAccountDisabled = (status: AccountStatus) =>
  [
    AccountStatus.Disabled,
    AccountStatus.WaitingForRisk,
    AccountStatus.WaitingForWithdraw,
  ].includes(status);
